import React from 'react';
import { alpha } from '@mui/material/styles';
import {
  Box, Card, CardContent, Divider, MenuItem, Select, Stack, Typography,
} from '@mui/material';

import { SHADOWS, TOKENS } from '../../../theme/muiTheme';
import { formatNumber } from '../../../shared/utils/number';

export default function ScopeHero({
  title,
  total,
  year,
  years,
  onYearChange,
  tone,
  icon: Icon,
  yearLabel,
  stats = [],
}) {
  return (
    <Card
      component="header"
      sx={{
        background: `linear-gradient(115deg, ${tone.color}, ${tone.dark})`,
        border: 0,
        boxShadow: SHADOWS.e2,
        color: 'common.white',
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 2.75 }, '&:last-child': { pb: { xs: 2, md: 2.75 } } }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          justifyContent="space-between"
          spacing={2}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems={{ xs: 'flex-start', md: 'center' }}
            spacing={{ xs: 1.5, md: 3 }}
            sx={{ minWidth: 0 }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Stack direction="row" alignItems="center" spacing={1} useFlexGap flexWrap="wrap">
                <Icon sx={{ fontSize: 20 }} />
                <Typography component="h1" variant="subtitle1" sx={{ fontSize: { xs: 18, md: 19 }, fontWeight: 800, lineHeight: 1.25 }}>
                  {title}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="baseline" spacing={0.9} sx={{ mt: 0.75 }}>
                <Typography
                  variant="kpiSecondary"
                  sx={{ color: 'inherit', fontSize: { xs: 32, sm: 40 }, fontVariantNumeric: 'tabular-nums' }}
                >
                  {formatNumber(total, { min: 2, max: 2 })}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700, fontSize: 17 }}>tCO₂e</Typography>
              </Stack>
            </Box>

            {stats.length > 0 && (
              <Stack
                direction="row"
                divider={(
                  <Divider
                    flexItem
                    orientation="vertical"
                    sx={{ borderColor: alpha(TOKENS.paper, 0.35) }}
                  />
                )}
                spacing={2.5}
                sx={{ alignSelf: { xs: 'stretch', md: 'center' } }}
              >
                {stats.map((stat) => (
                  <Box key={stat.label} sx={{ flex: { xs: 1, md: 'initial' }, minWidth: { md: 72 } }}>
                    <Typography sx={{ fontSize: 20, fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
                      {stat.value}
                    </Typography>
                    <Typography variant="caption" sx={{ color: alpha(TOKENS.paper, 0.78) }}>
                      {stat.label}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            )}
          </Stack>

          <Select
            size="small"
            value={year}
            onChange={(event) => onYearChange(Number(event.target.value))}
            inputProps={{ 'aria-label': yearLabel }}
            sx={{
              alignSelf: { xs: 'stretch', sm: 'center' },
              bgcolor: alpha(TOKENS.paper, 0.96),
              color: TOKENS.textPrimary,
              minWidth: { sm: 132 },
              '& .MuiSelect-select': { color: TOKENS.textPrimary },
            }}
          >
            {years.map((item) => (
              <MenuItem key={item} value={item}>{item}</MenuItem>
            ))}
          </Select>
        </Stack>
      </CardContent>
    </Card>
  );
}
